import { BufferAttributeModel, InvalidFormatError, IOHelper, JSONHelper, toJSONAttributeUsage, } from '@neo-one/client-common';
import { AttributeBase } from './AttributeBase';
import { AttributeUsage } from './AttributeUsage';
export class BufferAttribute extends AttributeBase(BufferAttributeModel) {
    constructor({ usage, value }) {
        super({ usage, value });
        this.size =
            this.usage === AttributeUsage.DescriptionUrl
                ? IOHelper.sizeOfUInt8 + IOHelper.sizeOfUInt8 + this.value.length
                : IOHelper.sizeOfUInt8 + IOHelper.sizeOfVarBytesLE(this.value);
    }
    static deserializeWireBase(options) {
        const { reader } = options;
        const { usage } = super.deserializeAttributeWireBase(options);
        if (!(usage === AttributeUsage.DescriptionUrl ||
            usage === AttributeUsage.Description ||
            usage === AttributeUsage.Remark ||
            usage === AttributeUsage.Remark1 ||
            usage === AttributeUsage.Remark2 ||
            usage === AttributeUsage.Remark3 ||
            usage === AttributeUsage.Remark4 ||
            usage === AttributeUsage.Remark5 ||
            usage === AttributeUsage.Remark6 ||
            usage === AttributeUsage.Remark7 ||
            usage === AttributeUsage.Remark8 ||
            usage === AttributeUsage.Remark9 ||
            usage === AttributeUsage.Remark10 ||
            usage === AttributeUsage.Remark11 ||
            usage === AttributeUsage.Remark12 ||
            usage === AttributeUsage.Remark13 ||
            usage === AttributeUsage.Remark14 ||
            usage === AttributeUsage.Remark15)) {
            throw new InvalidFormatError(`Invalid AttributeUsageModel. Received: ${usage}`);
        }
        const value = usage === AttributeUsage.DescriptionUrl ? reader.readBytes(reader.readUInt8()) : reader.readVarBytesLE();
        return new BufferAttribute({ usage, value });
    }
    serializeJSON(_context) {
        return {
            usage: toJSONAttributeUsage(this.usage),
            data: JSONHelper.writeBuffer(this.value),
        };
    }
}

//# sourceMappingURL=BufferAttribute.js.map
